var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAppointmentIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.929,
    height: 60.613,
    viewBox: "0 0 62.929 60.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M30.306,60.613a29.969,29.969,0,0,1-11.774-2.389A30.562,30.562,0,0,1,2.389,42.08a30.2,30.2,0,0,1,0-23.547A30.56,30.56,0,0,1,18.533,2.389a30.2,30.2,0,0,1,23.547,0A30.561,30.561,0,0,1,58.223,18.533a29.97,29.97,0,0,1,2.389,11.773q0,.127,0,.255a5.407,5.407,0,0,0-4.169-2.37,4.116,4.116,0,0,0-.427-.015,5.4,5.4,0,0,0-3.628,1.38l-1.1.893c0-.048,0-.095,0-.143A20.981,20.981,0,1,0,30.306,51.287a20,20,0,0,0,2.331-.127v9.361C31.78,60.583,31.018,60.613,30.306,60.613Zm0-27.975H20.981a2.331,2.331,0,1,1,0-4.663h6.994V16.319a2.331,2.331,0,1,1,4.663,0V30.306a2.324,2.324,0,0,1-2.331,2.331Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "document-edit-svgrepo-com",
    d: "M19.638.135a6.593,6.593,0,0,0-3,1.864L4.186,14.92c-.651.651-.68.5-1.464,2.487L0,25.275l8.21-2.591c2.237-.535,2.619-1.121,2.619-1.121L23.277,8.641c3.591-4.809.576-8.995-2.913-8.617a2.7,2.7,0,0,0-.726.111Z",
    transform: "translate(34.759 35.583) rotate(-8)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAppointmentIconMobile);
export default __webpack_public_path__ + "static/media/editAppointmentIconMobile.554a2b9a2cea18b6b1ae50decb09f6e4.svg";
export { ForwardRef as ReactComponent };